export default __webpack_public_path__ + "static/media/GetHelp_PerBusinessType.6dddb3da.svg";